module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page"
  }, [_c('div', {
    staticClass: "error-page__content"
  }, [_c('h1', {
    staticClass: "error-page__title"
  }, [_vm._v(_vm._s(_vm.code))]), _c('p', {
    staticClass: "error-page__description"
  }, [_vm._v(_vm._s(_vm.message))]), _c('pre', {
    staticClass: "error-page__errors"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', [_vm._v(_vm._s(error))])
  })), _c('base-button', {
    staticClass: "error-page__button",
    attrs: {
      "label": _vm.$t('go-to-homepage'),
      "url": "/"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507e84b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error/index.vue
// module id = 483
// module chunks = 0